var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 27"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M11.202 12.81.104 24.594A3 3 0 0 0 4.527 26.4l.031-.021 12.496-7.207-5.852-6.373z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    d: "M22.446 10.806h-.01l-5.393-3.14-6.081 5.413 6.102 6.102 5.371-3.098a3 3 0 0 0 1.575-2.639 2.97 2.97 0 0 0-1.564-2.628z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M.104 2.232c-.062.25-.104.501-.104.772v20.83c0 .27.031.521.104.771l11.484-11.483z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "m11.286 13.413 5.747-5.747L4.548.428A3 3 0 0 0 .105 2.222l11.191 11.18z"
  })));
};
export default SvgGoogle;